// extracted by mini-css-extract-plugin
module.exports = {"declaration":"_4x9zqXMMVhjKCk5tbsqlkQ==","footer":"poRyOljUmAYHInghDZtGtA=="};